module.exports = __webpack_public_path__ + "3fb5bce534aba4155fdfef5bda5e2955.png";